const countriesDictionary = {
  USA: {
    iso: 'USA',
    bounds: [231.679687, 23.885838, 293.027344, 49.610710]
  }
};

export default countriesDictionary;
